import { ROUTES } from '@/core/constants/routes'
import { FormCheckbox } from '@/core/ui/forms/checkbox'
import { Link } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'
import { useFormContext } from 'react-hook-form'

export const TermsAndConditionsCheckbox = () => {
  const t = useTranslations()
  const { control } = useFormContext()

  return (
    <FormCheckbox
      color='danger'
      name='termsAccepted'
      control={control}
      radius='sm'
      classNames={{
        icon: 'text-white text-lg font-bold stroke-4',
      }}
    >
      <p className='text-grey-50'>
        {t('acceptTerms.accept')}{' '}
        <Link
          href={ROUTES.terms}
          target='_blank'
          className='text-navy relative z-10 font-medium underline'
        >
          {t('links.terms')}
        </Link>{' '}
        {t('conjunctions.and')}{' '}
        <Link
          href={ROUTES.privacy}
          target='_blank'
          className='text-navy relative z-10 font-medium underline'
        >
          {t('links.privacy')}
        </Link>
      </p>
    </FormCheckbox>
  )
}
